import { render, staticRenderFns } from "./OutOfCompetitionButton.vue?vue&type=template&id=d944aefc&scoped=true"
import script from "./OutOfCompetitionButton.vue?vue&type=script&lang=ts"
export * from "./OutOfCompetitionButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d944aefc",
  null
  
)

export default component.exports